import { Button, Divider, Flex, Space, Text } from '@billy/design-system'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { AuditTrailAccountTable } from '../../types/AuditTrail'
import { AuditTrailTable } from '../AuditTrailTable'

interface AuditTrailViewProps {
  data: AuditTrailAccountTable[]
  isRefetching?: boolean
  showVoided: boolean
  setShowVoided: (show: boolean) => void
}

const Separator = ({ i }: { i: number }) => (
  <Flex key={`divider-${i}`} flexDirection="column">
    <Space size="s24" />
    <Divider />
    <Space size="s24" />
  </Flex>
)

export const AuditTrailView = ({ data, isRefetching, showVoided, setShowVoided }: AuditTrailViewProps) => {
  const { t } = useTranslation()
  const auditTrailStartRef = useRef<HTMLDivElement>(null)

  const handleGoToAuditTrailStart = () => {
    auditTrailStartRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <>
      <div ref={auditTrailStartRef}>
        <Flex flexDirection="column">
          <Flex justifyContent="space-between">
            <Text variant="h2">{t('vat_declaration.audit_trail')}</Text>
            {/* Temporary hiding this functionality */}
            {/* <Button variant="outlined" icon={showVoided ? 'eye' : 'eyeOff'} onClick={() => setShowVoided(!showVoided)}>
              {showVoided ? t('vat_declaration.audit_trail.hide_voided') : t('vat_declaration.audit_trail.show_voided')}
            </Button> */}
          </Flex>
          <Space />

          {data.map((table, index) => (
            <React.Fragment key={`${table.tableName}-${showVoided}`}>
              <AuditTrailTable data={table} isRefetching={isRefetching} />
              {index < data.length - 1 && <Separator i={index} />}
            </React.Fragment>
          ))}
        </Flex>
      </div>

      <Space size="s40" />
      <Button variant="text" onClick={handleGoToAuditTrailStart}>
        <Text variant="bodyMD" weight="semiBold">
          {t('audit_trail.go_to_top')}
        </Text>
      </Button>
    </>
  )
}
